import { gql } from '@apollo/client'

export const findAllSellTOUGQL = gql`
  query findAllSellTOU {
    findAllSellTOU {
      _id
      name
      custId
    }
  }
`

export const CreateSellTOUGQL = gql`
  mutation createSellTOU($val: CreateSellTOUInput!) {
    createSellTOU(createSellTOUInput: $val) {
      _id
    }
  }
`

export const UpdateSellTOUGQL = gql`
  mutation updateSellTOU($val: UpdateSellTOUInput!) {
    updateSellTOU(updateSellTOUInput: $val) {
      _id
    }
  }
`

export const findOneSellTOUGQL = gql`
  query findOneSellTOU($val: String!) {
    findOneSellTOU(_id: $val) {
      _id
      name
      custId
      cust {
        _id
        name
        KEPCOPlanType {
          _id
          name
        }
        prevKEPCOContractedPower
        re100Opt
        loadOpt
      }
      touVer
      holidayYear
      environmentalUnit
      buyTOUList {
        _id
        name
        custId
        cust {
          _id
          name
          facilityCapacity
          previousMethod
          revenueContractType
          contractPrice
          RECWeight
          pvOpt
        }
      }
      essPowerRate
      afterKEPCOContractedPower
      planType
      rateOpt
      networkOpt
      internalNetworkUnitBaseUnit
      internalNetworkUnitPowerUnit
      distributionUnitBaseUnit
      distributionUnitUsageUnit
      lossCostMinUnit
      lossCostMidUnit
      lossCostMaxUnit
      additionalSettlementUnit
      transactionCommissionUnit
      discountedPriceUnit
      transmissionLossCostUnit
      ectCostUnit
      greenPremiumUnit
      essProfitRate
      chargeUnitResult {
        spr {
          min
          mid
          max
        }
        sum {
          min
          mid
          max
        }
        fall {
          min
          mid
          max
        }
        win {
          min
          mid
          max
        }
      }
      touPeriodResult {
        spr {
          week
          sat
          holi
        }
        sum {
          week
          sat
          holi
        }
        fall {
          week
          sat
          holi
        }
        win {
          week
          sat
          holi
        }
      }
      sprMinMidRate
      sprMinMaxRate
      sumMinMidRate
      sumMinMaxRate
      fallMinMidRate
      fallMinMaxRate
      winMinMidRate
      winMinMaxRate
    }
  }
`

export const DeleteSellTOUGQL = gql`
  mutation deleteSellTOU($val: String!) {
    deleteSellTOU(_id: $val) {
      _id
    }
  }
`

export const findAllLoadCustGQL = gql`
  query findAllLoadCust {
    findAllLoadCust {
      _id
      name
    }
  }
`

export const findLoadDataGQL = gql`
  query findLoadData($val: String!) {
    findLoadData(_id: $val) {
      date
      value
    }
  }
`
